/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const CheckoutActor = zod.object({
	email: zod.string().optional().describe('Optional actor email'),
	id: zod.string().describe("External actor ID from the customer's system"),
	kind: zod.enum(['human', 'agent']).optional(),
	metadata: zod.looseObject({}).optional().describe('Optional actor metadata'),
	name: zod.string().optional().describe('Optional actor name')
});

export type CheckoutActor = zod.input<typeof CheckoutActor>;
export type CheckoutActorOutput = zod.output<typeof CheckoutActor>;
